module.exports = __webpack_public_path__ + "static/5-53f442aff2bbb71e1b4140810768c174.png";